import React from 'react';
import { DataTable, SummaryCard } from './CommercialCommon';

export default function CommercialDashboardTab({ workspace }) {
  const summary = workspace.summary;
  const statuses = Object.entries(summary?.statusBreakdown || {});

  return (
    <>
      <section className="commercial-panel">
        <p className="commercial-panel__eyebrow">Dashboard</p>
        <h2 className="commercial-panel__title">Operational Snapshot</h2>
        <p className="commercial-panel__copy">
          This dashboard gives you a live view of workload, dispatch activity, technicians, customers, and assets.
        </p>
        <div className="commercial-summary-grid">
          <SummaryCard label="Open Work Orders" value={summary.openWorkOrderCount} tone="warning" />
          <SummaryCard label="Dispatch Queue" value={summary.dispatchQueueCount} tone="accent" />
          <SummaryCard label="Available Technicians" value={summary.dispatchableTechnicianCount} tone="success" />
          <SummaryCard label="Customers" value={summary.customerCount} />
          <SummaryCard label="Assets" value={summary.assetCount} />
          <SummaryCard label="Locations" value={summary.locationCount} />
        </div>
      </section>

      <section className="commercial-grid commercial-grid--equal">
        <section className="commercial-panel">
          <p className="commercial-panel__eyebrow">Recent Work</p>
          <h2 className="commercial-panel__title">Recent Work Orders</h2>
          <DataTable
            columns={[
              { key: 'workOrderNumber', label: 'Work Order' },
              { key: 'title', label: 'Title' },
              { key: 'status', label: 'Status' },
              { key: 'priority', label: 'Priority' },
              { key: 'assignedTechnicianName', label: 'Assigned To', render: row => row.assignedTechnicianName || 'Unassigned' },
            ]}
            rows={workspace.workOrders.slice(0, 6)}
            emptyMessage="No work orders yet."
          />
        </section>

        <section className="commercial-panel commercial-panel--subtle">
          <p className="commercial-panel__eyebrow">Status Mix</p>
          <h2 className="commercial-panel__title">Work Order Status</h2>
          <div className="commercial-stat-list">
            {statuses.map(([status, count]) => (
              <div key={status} className="commercial-stat-list__row">
                <span>{status.replaceAll('_', ' ')}</span>
                <strong>{count}</strong>
              </div>
            ))}
          </div>
        </section>
      </section>
    </>
  );
}
